import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SIGNED_OUT_CONFIG } from '../../components/signed-out/signed-out.config';
import { LastAppCookieService } from '../../services/last-app-cookie.service';
import { parseSignedOutReason } from '../../utils/signed-out-utils/signed-out-utils';

// A stale login that lands on CrownBase belongs on the Stock app when that is where the device was last used.
export const stockAppForwardGuard: CanActivateFn = route => {
  const config = inject(SIGNED_OUT_CONFIG);
  const lastApp = inject(LastAppCookieService).read(config.lastAppCookieName);
  const reason = parseSignedOutReason(route.queryParamMap.get('reason'));
  // Auth0's stale-login landing comes without a returnTo; CrownBase's own expiries always carry one and stay here.
  const staleLogin = reason === 'expired' && !route.queryParamMap.has('returnTo');
  if (!staleLogin || !config.stockAppSignedOutUrl || lastApp !== 'stock') {
    return true;
  }
  inject(DOCUMENT).location.replace(`${config.stockAppSignedOutUrl}?reason=expired`);
  return false;
};
